import { List, Create, Edit, View, MyPreSanction, Copy, Details } from "../Components/index.js";

export default [
    {
        path: "/voucher/canteen/my-pre-sanction",
        component: MyPreSanction,
        name: "canteen.voucher.my.pre-sanction",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/canteen/pre-sanction",
        component: List,
        name: "canteen.voucher.pre-sanction",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/canteen/pre-sanction/create",
        component: Create,
        name: "canteen.voucher.pre-sanction.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/canteen/pre-sanction/:id/edit",
        component: Edit,
        name: "canteen.voucher.pre-sanction.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/canteen/pre-sanction/:id/view",
        component: View,
        name: "canteen.voucher.pre-sanction.view",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/canteen/pre-sanction/:id/copy",
        component: Copy,
        name: "canteen.voucher.pre-sanction.copy",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/reports/canteen/pre-sanction/details/:id",
        component: Details,
        name: "report.canteen.presanction.details",
        meta: {
            requiresAuth: true,
        },
    },
];
